import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { useFilters } from '@domain-group/react-hooks'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import useTrainingModule from '@hooks/useTrainingModule'
import useTrainingModules from '@hooks/useTrainingModules'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import TrainingModuleListItem from './TrainingModuleListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Title',
    },
  ]
}

const TrainingModules = (props: { trainingCourseId: number }) => {
  const { trainingCourseId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const options = {
    filters: { training_course_id: trainingCourseId, ...pageFilters },
    performHttpRequests: !!trainingCourseId,
    requestOptions: {
      include_training_module_lesson_count: true,
    },
  }

  const trainingModulesPayload = useTrainingModules(options)
  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredTrainingModuleCount,
    filteredTrainingModules,
    hasFilteredTrainingModule,
    loading,
  } = trainingModulesPayload

  const {
    callbacks: { createOrDuplicateTrainingModule },
  } = useTrainingModule({ training_course_id: trainingCourseId })

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Training Modules"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      <Box flexDirection="column">
        {!loading && !hasFilteredTrainingModule && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Training Modules present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please assign a Training Module below.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredTrainingModule && (
          // @ts-expect-error TS2322
          <DashboardModule.ScrollableSection flexDirection="column">
            {filteredTrainingModules.map(trainingModule => (
              <TrainingModuleListItem
                key={trainingModule.id}
                trainingModule={trainingModule}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredTrainingModuleCount}
          loading={loading}
        >
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => createOrDuplicateTrainingModule()}
            // @ts-expect-error TS2322
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Training Module
          </Button>
        </DashboardModule.LoadMoreFooter>
      </Box>
    </DashboardModule>
  )
}

export default TrainingModules
